export default __webpack_public_path__ + "static/media/esports-bg.07ce6af3.webp";